// Browsers report a timeout as code 3, Capacitor 8 as OS-PLUG-GLOC-0010 on Android and iOS
const timeoutCodes: unknown[] = [3, 'OS-PLUG-GLOC-0010']

export const isLocationTimeoutError = (error: unknown) => {
  if (typeof error !== 'object' || error === null) return false

  return 'code' in error && timeoutCodes.includes(error.code)
}
